import React, { useState } from "react";

interface ServerSelectFilterProps {
  options: string[];
  onChange: (value?: string) => void;
}

const ServerSelectFilter = ({ options, onChange }: ServerSelectFilterProps) => {
  const [value, setValue] = useState<string>("");

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newValue = e.target.value;
    setValue(newValue);
    onChange(newValue || undefined);
  };

  return (
    <select
      className={
        "w-100 h-100 ps-2 me-2 " + // layout - "me-2" -> container a bit smaller on the right side so that the dropdown icon is not touching the container
        "bg-transparent " + // color
        "border-0 rounded-pill " + // design
        "fs-6 " // font
      }
      value={value}
      onChange={handleChange}
      style={{ color: value === "" ? "#767676" : "#333" }}
      aria-label="Auswählen"
    >
      {/* Placeholder option */}
      <option value="">Auswählen...</option>
      {/* Regular Options */}
      {options.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
  );
};

export default ServerSelectFilter;
